import * as React from 'react'

import './Avatar.css';

type AvatarSize = "small" | "medium";

interface IAvatarProps {
    size?: AvatarSize,
    imageUrl: string
}

class Avatar extends React.Component<IAvatarProps> {
    public constructor(props: IAvatarProps) {
        super(props);
    }
    public render() {
        return (
            <img className={'Avatar Avatar--' + this.props.size} src={this.props.imageUrl} />
        );
    }
}

export default Avatar;


// WEBPACK FOOTER //
// ./src/App/Elements/Avatar.tsx